<template>
  <v-app id="inspire">
    <v-content>
      <v-container
        class="fill-height"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="10"
            md="4"
          >
            <v-card outlined>
              <v-img
                class="mx-auto mt-10"
                max-height="200"
                max-width="200"
                :src="logoB"
              />
              <v-card-text class="text-center">
                <p>Your account has not been verified.</p>
                <p>Please wait for admin to approve your account.</p>
                <a @click="gotoLogin">Click here to go back to login page.</a>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>
<script type="text/javascript">
  export default {
    methods: {
      gotoLogin() {
        this.$router.push({ path: '/login' });
      }
    },
    computed: {
      logoB() {
        return process.env.VUE_APP_LOGO_B;
      },
    },
  }
</script>
